<div class="mb-1" style="padding:0px">
  <hr />
  <div class="row" style="margin-top:-35px">
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-success" *ngIf="package.stepnumber > 1"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="package.stepnumber == 1">1</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Tracking Number</h5>
        </div>
        <div class="col-12" style="text-align:center">
          <span class="text-muted">{{package.trackingNumber}}</span>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-success" *ngIf="package.stepnumber > 2"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="package.stepnumber == 2">2</span>
          <span class="badge badge-pill badge-secondary" *ngIf="package.stepnumber < 2">2</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Shipper Info</h5>
        </div>
        <div class="col-12" style="text-align:center">
          <span class="text-muted" [hidden]="package.shipmentTypeDisplay == null">{{package.shipmentTypeDisplay}}<br />{{package.DeliveredDate | date:'MM/dd/yyyy hh:mm a'}}</span>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-success" *ngIf="package.stepnumber > 3"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="package.stepnumber == 3">3</span>
          <span class="badge badge-pill badge-secondary" *ngIf="package.stepnumber < 3">3</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Client</h5>
        </div>
        <div class="col-12" style="text-align:center">
          <span class="text-muted" [hidden]="package.client == null">{{package.client?.OriginalName}}</span>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-success" *ngIf="package.stepnumber > 4"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="package.stepnumber == 4">4</span>
          <span class="badge badge-pill badge-secondary" *ngIf="package.stepnumber < 4">4</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Sender Address</h5>
        </div>
        <div class="col-12" style="text-align:center">
          <span class="text-muted" [hidden]="package.FromName == null">{{package.FromName}}<br />{{package.FromAddress1}}<br />{{package.FromCity}} {{package.FromState}} {{package.FromZipCode}}</span>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-dark" *ngIf="package.packageFound"><i style="color:white" class="fas fa-times"></i></span>
          <span class="badge badge-pill badge-success" *ngIf="!package.packageFound && package.stepnumber > 5"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="!package.packageFound && package.stepnumber == 5">5</span>
          <span class="badge badge-pill badge-secondary" *ngIf="!package.packageFound && package.stepnumber < 5">5</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Print Label</h5>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col-12 h4" style="text-align:center">
          <span class="badge badge-pill badge-success" *ngIf="package.stepnumber > 6"><i style="color:white" class="fas fa-check"></i></span>
          <span class="badge badge-pill badge-primary" *ngIf="package.stepnumber == 6">6</span>
          <span class="badge badge-pill badge-secondary" *ngIf="package.stepnumber < 6">6</span>
        </div>
        <div class="col-12" style="text-align:center">
          <h5>Complete</h5>
        </div>
      </div>
    </div>
  </div>
</div>
